<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF INNER BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h1 class="h2-title mb-0 mt-5">Careers</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF INNER BANNER -->
    <!-- START OF ABOUT US -->
    <section class="about-us">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="about-us-content wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Careers
                            </span>
                            <p style="line-height: 30px;" class="mb-3">
                                As a manufacturer of lubricants <span class="text-theme fw-medium">Golden Drop
                                    Oils</span>
                                operates as an innovation-driven group focused on powering performance throughout the
                                United Arab Emirates. The fast-growing nature of our company makes integrity and
                                collaboration and ongoing learning essential values to us all.
                            </p>
                            <p style="line-height: 30px;">
                                <span class="text-theme fw-medium">Golden Drop Oils</span> provides employment
                                opportunities in engineering and sales departments and logistics and customer support
                                units which match the passion of qualified applicants.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF ABOUT US -->

    <section class="how-we-work light-bg">
        <div class="container">
            <div class="sec-title text-center wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                <h2 class="h3-title mb-5">Why Work With Us?</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>01</span>
                        <p>
                            The workplace offers an innovative culture that enables employees to drive revolutionary
                            progress in lubricant technology development.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>02</span>
                        <p>
                            Working at the company allows employees to take advantage of continuous training
                            opportunities together with mentorship programs and establish structured advancement tracks
                            through technical certificates up to leadership positions.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>03</span>
                        <p>
                            Our company provides employees with opportunities to collaborate with industry experts at
                            both Dubai and Sharjah locations that have state-of-the-art offices and labs.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>04</span>
                        <p>
                            Golden Drop Oils provides top market compensation together with comprehensive healthcare
                            benefits and distinctive performance awards and flexible leave schedules.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>05</span>
                        <p>
                            Contribute to eco‑friendly formulations and responsible sourcing as part of our commitment
                            to the environment.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- START OF JOINING SECTION -->
    <section class="careers join-us wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="join-us-content dark-bg">
                        <div class="sec-title">
                            <h2 class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Call to Action
                            </h2>
                            <p class="text-white">
                                Golden Drop Oils awaits qualified candidates to start their career advancement. Our
                                Careers page features available positions so applicants can access them while sending their CVs
                                to join our team working towards better performance and sustainable innovation from the
                                UAE’s center.
                            </p>
                        </div>
                        <img src="assets/img/join-our-team.png" width="271" height="271" alt="Join our team image">
                        <a routerLink="/contact" class="sec-btn" title="Contact Us">Contact Us</a>
                        <div class="banner-shape">
                            <span class="stripe"></span>
                            <span class="stripe stripe-secondary"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF JOINING SECTION -->

</main>
<!-- END OF MAIN -->